export const replaceHref = (trackingNumber) => {
  let href = new URL(window.location.href);
  if (trackingNumber && trackingNumber.length > 0) {
    href.searchParams.set("tracking_number", trackingNumber);
  }
  if (window.history.pushState) {
    window.history.pushState({ path: href.href }, "", href.href);
  }
};
